import { Box, TextField, Typography, Button } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useNotify, useRefresh } from 'react-admin';
import dataProvider from '../../providers/dataProvider';
import { Credit } from '../../types/user';
import RichTextEditor from 'react-rte';
import { getDate } from '../../helpers/dateHelper';
import "./index.css";


interface Props {
    closeModal: () => void,
    id: string;
    isEdit: boolean;
    credit?: Credit;
    isView: boolean;
}

const AddEditCredits: FC<Props> = ({ closeModal, id, isEdit, credit, isView }) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const [state, setState] = useState({
        description: RichTextEditor.createValueFromString('<p>Added by Admin</p>','html') //'<p>Added by Admin</p>'
    })

    const [creditsCount, setCreditsCount] = useState(1)

    useEffect(() => {
        if (isEdit && credit) {
            setCreditsCount(credit.amount / 100)
            setState({ ...state, description: RichTextEditor.createValueFromString(credit.description, 'html') })
        }
    }, [])

    const handleDescription = (value: string): void => {
        if (!isView) {
            setState({ ...state, description: value })
        }
    }

    const handleCreditsCount = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (parseInt(e.currentTarget.value) < 1 ) {
            return
        }
        setCreditsCount(parseInt(e.currentTarget.value))
    }

    const saveCredits = async (): Promise<void> => {
        if (!isEdit) {
            const expiredDate = new Date(Date.now() + (30 * 24 * 60 * 60 * 1000));
            const data: Credit = {
                amount: creditsCount,
                description: state.description.toString('html'),
                createdDate: new Date(Date.now()),
                expiredDate: expiredDate
            }
            const result = await dataProvider.addCredits(id, data)
            if (result.data) {
                notify("Credits added", "info")
                closeModal()
                refresh()
            }
        } else {
            if (credit) {
                const editedCredit: Credit = {
                    amount: creditsCount,
                    description: state.description.toString('html'),
                    createdDate: credit.createdDate,
                    expiredDate: credit.expiredDate
                }
                const result = await dataProvider.update("credits", {
                    data: editedCredit,
                    id: credit._id,
                }) as any
                if (result.data) {
                    notify("Credits edited", "info")
                    closeModal()
                    refresh()
                }
            }
        }
    }
    return (
        <>
            <Box padding="2em">
                <Box display="flex" justifyContent="center" padding="1em">
                    {!isView ?
                        <Typography variant="h6" className="base-color">
                            {isEdit ? "Edit Credits details" : "Add Credits"}
                        </Typography> :
                        <Typography variant="h6" className="base-color">
                            View Credits details
                    </Typography>
                    }
                </Box>
                <Box display="flex" justifyContent="flex-start" alignItems="center" padding="1em">
                    <TextField
                        type="number"
                        label=""
                        className="add-credits"
                        value={creditsCount}
                        inputProps={{ step: 1 }}
                        onChange={handleCreditsCount}
                        defaultValue={1}
                        required
                        disabled={isView}
                    />
                    <Typography className="base-color">
                        Credits
                    </Typography>
                    {credit &&
                        <Box display="flex">
                            <div className="show-date">
                                Date
                          </div>
                            <Typography className="base-color">
                                {getDate(new Date(credit.createdDate))}
                            </Typography>
                        </Box>}
                </Box>
                <Box>
                    <Typography className="base-color">
                        Description
                    </Typography>
                    <Box className="credit-description">
                        <RichTextEditor
                            value={state.description}
                            onChange={handleDescription} />
                    </Box>
                </Box>
                <Box display="flex" justifyContent="space-evenly" paddingTop="1em" >
                    {!isView && <Button className="user-cancel-button user-modal-buttons" disabled={creditsCount ? false : true} onClick={saveCredits}>Save</Button>}
                    <Button className="user-cancel-button user-modal-buttons" onClick={closeModal}>{isView ? "Ok" : 'Cancel'}</Button>
                </Box>
            </Box>
        </>
    )
}

export default AddEditCredits